const i = "_divider_1m5h4_1", d = "_isVertical_1m5h4_9", e = {
  divider: i,
  isVertical: d,
  "section-divider": "_section-divider_1m5h4_15",
  "header-divider": "_header-divider_1m5h4_19",
  "brand-divider": "_brand-divider_1m5h4_23"
};
export {
  e as default,
  i as divider,
  d as isVertical
};
//# sourceMappingURL=index.es648.js.map
